<script lang="ts" setup>
import ButtonPrime, { type ButtonSlots, type ButtonEmits, type ButtonProps } from 'primevue/button'

interface Props extends /* @vue-ignore */ Omit<ButtonProps, 'label' | 'icon'> {
  label?: ButtonProps['label']
  icon?: ButtonProps['icon']
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ ButtonEmits {}

const props = defineProps<Props>()
defineEmits<Emits>()

const slots = defineSlots<ButtonSlots>()
</script>

<template>
  <ButtonPrime v-bind="props">
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="slotData"
      />
    </template>
  </ButtonPrime>
</template>
